module.exports = __webpack_public_path__ + "img/logo.f7cbc0b1.png";